export const SET_EMAILFAMILIES = "SET_EMAILFAMILIES";
export const ADD_EMAILFAMILY = "ADD_EMAILFAMILY";
export const DELETE_EMAILFAMILY = "DELETE_EMAILFAMILY";
export const ADD_EMAILTYPE = "ADD_EMAILTYPE";
export const DELETE_EMAILTYPE = "DELETE_EMAILTYPE";
export const ADD_EMAILEXCELID = "ADD_EMAILEXCELID";
export const DELETE_EMAILEXCELID = "DELETE_EMAILEXCELID";